// @greenlight-spec: decisions/0026-integration-catalog-and-connection-profiles.md
// @greenlight-spec: 09-data-brokering.md
/**
 * USCIS Torch API (Case Status) client-credentials registration guide.
 *
 * Sandbox and production are the same API on different hosts, and USCIS grants the
 * production host only after reviewing the app — so the steps register against the
 * sandbox host first and treat the move to production as editing one field.
 */
export const USCIS_CASE_STATUS_STEPS = [
    {
        title: 'Create a USCIS Developer Portal account',
        body: 'Register at developer.uscis.gov and sign in. Use a team-owned account rather than an individual one — the credentials below belong to the organization, not to whoever created them.',
    },
    {
        title: 'Create a Team App and subscribe it to the Case Status API',
        body: 'In the portal, create a Team App and add the Case Status API to it. The app is what carries the credentials; the API subscription is what those credentials are allowed to reach.',
    },
    {
        title: 'Copy the Client ID and Client Secret',
        body: 'The Team App issues a Client ID and Client Secret. Put the Client ID in Client ID on this form and paste only the Client Secret under Credentials.\n' +
            'Greenlight mints the bearer token itself against the USCIS OAuth endpoint on the host you entered above; the app never sees either value.',
    },
    {
        title: 'Start on the sandbox host',
        body: 'Enter api-int.uscis.gov as the USCIS API host. Sandbox credentials are issued immediately and answer with USCIS test receipt numbers, so an app can be built and demonstrated before any approval.',
    },
    {
        title: 'Switch to production once USCIS approves the app',
        body: 'Production access is granted per app after USCIS review. When it is, edit this integration and change the host to api.uscis.gov — the credentials, the token endpoint path, and the app code are unchanged.\n' +
            'Apps read a case with GET /case-status/{receipt_number} against the registered base URL.',
    },
];
//# sourceMappingURL=uscis-case-status-guide.js.map